package com.daytimegaming.ourdailyfinances.domain.model

data class Account(
    val accountId: String,
    val name: String,
    val officialName: String?,
    val type: String,
    val subtype: String?,
    val currentBalance: Double?,
    val availableBalance: Double?,
    val isoCurrencyCode: String?,
    val institutionName: String?,
    val itemId: String?,
    val loginRequired: Boolean = false,
    val updateRequired: Boolean = false,
    val subscriptionRequired: Boolean = false,
    val nickname: String? = null,
) {
    val displayName: String
        get() = if (!nickname.isNullOrEmpty()) nickname else name
}
